/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsReplaceAodRulesByIdMutationRequest, AuditReportsReplaceAodRulesByIdMutationResponse, AuditReportsReplaceAodRulesByIdPathParams, AuditReportsReplaceAodRulesById401, AuditReportsReplaceAodRulesById403 } from "../models/AuditReportsReplaceAodRulesById";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsReplaceAodRulesById } from "../axios/auditReportsReplaceAodRulesById";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsReplaceAodRulesByIdMutationKey = () => [{ url: '/audit-reports/v1/aod-rules/:id' }] as const

export type AuditReportsReplaceAodRulesByIdMutationKey = ReturnType<typeof auditReportsReplaceAodRulesByIdMutationKey>

export function auditReportsReplaceAodRulesByIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuditReportsReplaceAodRulesByIdMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = auditReportsReplaceAodRulesByIdMutationKey()
        return mutationOptions<AuditReportsReplaceAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsReplaceAodRulesById401 | AuditReportsReplaceAodRulesById403>, {id: AuditReportsReplaceAodRulesByIdPathParams["id"], data: AuditReportsReplaceAodRulesByIdMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return auditReportsReplaceAodRulesById(id, data, config)
          },
        })

}

/**
 * @summary Replace a single AodRule
 * {@link /audit-reports/v1/aod-rules/:id}
 */
export function useAuditReportsReplaceAodRulesById<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsReplaceAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsReplaceAodRulesById401 | AuditReportsReplaceAodRulesById403>, {id: AuditReportsReplaceAodRulesByIdPathParams["id"], data: AuditReportsReplaceAodRulesByIdMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuditReportsReplaceAodRulesByIdMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsReplaceAodRulesByIdMutationKey()

          const baseOptions = auditReportsReplaceAodRulesByIdMutationOptions(config) as UseMutationOptions<AuditReportsReplaceAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsReplaceAodRulesById401 | AuditReportsReplaceAodRulesById403>, {id: AuditReportsReplaceAodRulesByIdPathParams["id"], data: AuditReportsReplaceAodRulesByIdMutationRequest}, TContext>
          

          return useMutation<AuditReportsReplaceAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsReplaceAodRulesById401 | AuditReportsReplaceAodRulesById403>, {id: AuditReportsReplaceAodRulesByIdPathParams["id"], data: AuditReportsReplaceAodRulesByIdMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsReplaceAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsReplaceAodRulesById401 | AuditReportsReplaceAodRulesById403>, {id: AuditReportsReplaceAodRulesByIdPathParams["id"], data: AuditReportsReplaceAodRulesByIdMutationRequest}, TContext>
      
}